import { ButtonProps } from 'types';
import { Spinner } from 'components/Spinner';

import cx from 'classnames';
import styles from './Button.module.scss';
import Lottie, { LottieRefCurrentProps, AnimationDirection } from 'lottie-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';

export const ButtonLottie = ({
                         action,
                         buttonType = 'blue',
                         buttonHeight = '',
                         caption,
                         className,
                         captionClassName,
                         disabled = false,
                         fit = true,
                         iconSrc,
                         iconSrcRight,
                         iconOnly = false,
                         id,
                         shape = 'wide',
                         withoutBorder,
                         withSpinner = false,
                         largeIcon,
                         isBoldText,
                         btnNativeProps = {},
                         isActive,
                         lottie,
                       }: ButtonProps) => {
  const [active, setActive] = useState(isActive);
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    setActive(isActive)
    if (lottieRef.current && active!==isActive) {
      lottieRef.current.goToAndStop(isActive ? 30 : 0, true);
    }
  }, [isActive]);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(isActive ? 30 : 0, true);
    }
  }, []);

  const playSegment = (segments: any, direction: AnimationDirection) => {
    lottieRef?.current?.setDirection(direction);
    lottieRef?.current?.playSegments(segments, true);
  };

  const onPress = useCallback((event, active?: boolean) => {
    if (!active) {
      playSegment([0, 30], 1); // лайк
    } else {
      playSegment([30, 0], -1); // анлайк
    }
    setActive(!active)
    action(event, active)
  }, []);

  return (
    <button
      {...btnNativeProps}
      id={id}
      className={cx(
        styles.default_button,
        styles[`${buttonType}`],
        styles[`${buttonHeight}`],
        styles[`${shape}`],
        {
          [styles.fit]: iconSrc && fit,
          [styles.iconOnly]: iconOnly,
          [styles.largeIcon]: largeIcon,
          [styles.withoutBorder]: withoutBorder,
        },
        className,
      )}
      onClick={(event) => onPress(event, active)}
      disabled={disabled || withSpinner}
    >
      {withSpinner && <Spinner className={styles.buttonSpinner} />}
      <div style={{width: 24, height: 24}}>
        <Lottie
          lottieRef={lottieRef}
          animationData={lottie}
          loop={false}
          autoplay={false}
          style={{ marginTop: -7 }}
        />
      </div>
      {caption ? <p className={cx(styles.content, styles.indent, { [styles.indentRight]: iconSrcRight, [styles.boldText]: isBoldText }, captionClassName)}>{caption}</p> : null}
    </button>
  );
};
